<template>
  <div class="container box_component competition-view-shell">
    <button
        type="button"
        class="competition-back-button"
        @click="onCancel"
    >
      <i class="fas fa-arrow-left"></i>
      <span>{{ $t('profile.btn_back') || 'Volver' }}</span>
    </button>

    <CompetitionHeader
        :competition="competitionArray"
        :defaultImage="defaultImage"
      @countdown-complete="handleCountdownComplete"
    />
    <CompetitionDetails :competition="competitionArray"/>

    <CompetitionExtraInfo :competition="competitionArray"/>

    <CompetitionRoundSizes :competition="competitionArray" />

    <CompetitionStageCalendar
      v-if="showStageCalendar"
      :competition="competitionArray"
    />
  </div>

  <div v-if="hasActions" class="container box_component">
    <CompetitionActions
        :competition="competitionArray"
        :countdownReached="countdownReached"
      :showYoutubeControls="false"
      :showCancelButton="false"
        @startScoring="handleStartScoring"
        @viewAthletes="handleViewAthletes"
        @viewJudges="handleViewJudges"
        @viewRounds="handleViewRounds"
        @openScoring="handleOpenScoring"
        @openRecording="handleOpenRecording"
        @orderAthletes="handleOrderFromActions"
        @roundSizesLockedAll="handleRoundSizesLockedAll"
        @cancel="onCancel"
    />

    <ConfirmationModal
        ref="confirmationModal"
        :message="modalMessage"
        :showCancel="showCancel"
        @confirmed="confirmModal"
        @canceled="cancelModal"
    />
  </div>
  <div v-if="showAthletes || showJudges || showRounds || enableJudgesManual || enableRecordingManual" class="container box_component"  ref="sectionContainer">
    <CompetitionAthletes
        v-if="showAthletes"
      ref="competitionAthletes"
        :athletes="athletes"
        :athletes_list="athletes_list"
        :competition="competitionArray"
        @viewAthlete="viewAthlete"
        @deleteAthlete="deleteAthlete"
        @rejectAthlete="rejectAthlete"
        @confirmPayment="confirmPayment"
        @confirmAthlete="confirmAthlete"
        @inviteAthletes="inviteAthlete"
        @approveAthlete="approveAthlete"
        @sendEmailToAthletes="sendEmailToAthletes"
        @sendEmailToAthlete="sendEmailToAthlete"
        @orderAthletes="orderAthletes"
        @register="handleRegister"
    />
    <CompetitionJudges
        v-if="showJudges"
        :judges="judges"
        :judges_list="judges_list"
        :competition="competitionArray"
        @viewJudge="viewJudge"
        @deleteJudge="deleteJudge"
        @rejectJudge="rejectJudge"
        @inviteJudges="inviteJudges"
        @approveJudge="approveJudge"
        @confirmJudge="confirmJudge"
        @sendEmailToJudges="sendEmailToJudges"
        @sendEmailToJudge="sendEmailToJudge"
      @toggleTechOperator="toggleTechOperator"

    />
    <CompetitionRounds
        v-if="showRounds"
        :competition="competitionArray"
        @advance-stage="advanceStage"
        @publish-stage="publishStage"
        @view-round="viewRound"
        @review-round="reviewRound"
    />
    <CompetitionJudge
      v-if="enableRecordingManual"
      :competition="competitionArray"
      :allowRecording="true"
      @start-recording-athlete="startRecordingAthlete"
      @stop-recording-athlete="stopRecordingAthlete"
      @score-athlete="scoreAthlete"
      @disqualify-athlete="disqualifyAthlete"
      @injury-athlete="injuryAthlete"
      @view-score="viewScore"
      @edit-score="editScore"
      @update-status="updateAthleteStatus"
    />

    <CompetitionJudge
      v-if="enableJudgesManual"
      :competition="competitionArray"
      :allowRecording="false"
      @start-recording-athlete="startRecordingAthlete"
      @stop-recording-athlete="stopRecordingAthlete"
      @score-athlete="scoreAthlete"
      @disqualify-athlete="disqualifyAthlete"
      @injury-athlete="injuryAthlete"
      @view-score="viewScore"
      @edit-score="editScore"
      @update-status="updateAthleteStatus"
    />

  </div>
  <RegisterAthleteModal
      :isVisible="showRegisterModal"
      :competitionId="selectedCompetitionId"
      @close="showRegisterModal = false"
      @registered="handleRegistered"
  />

  <loading-modal ref="loadingModal"></loading-modal>
</template>

<script>
import {mapActions, mapState } from "vuex";
import LoadingModal from "@/services/LoadingModal.vue";
import ConfirmationModal from "@/components/competitions/ConfirmationModal.vue";
import CompetitionDetails from "@/components/competitions/CompetitionDetails.vue";
import CompetitionRoundSizes from "@/components/competitions/CompetitionRoundSizes.vue";
import CompetitionExtraInfo from "@/components/competitions/CompetitionExtraInfo.vue";
import CompetitionHeader from "@/components/competitions/CompetitionHeader.vue";
import CompetitionActions from "@/components/competitions/CompetitionActions.vue";
import CompetitionStageCalendar from "@/components/competitions/CompetitionStageCalendar.vue";
import CompetitionAthletes from "@/components/competitions/CompetitionAthletes.vue";
import CompetitionRounds from "@/components/competitions/CompetitionRounds.vue";
import CompetitionJudge from "@/components/competitions/CompetitionJudge.vue";
import CompetitionJudges from "@/components/competitions/CompetitionJudges.vue";
import RegisterAthleteModal from '@/components/competitions/RegisterAthleteModal.vue';
import echoService from "@/services/echoService";
import router from "@/router/router";
import { fetchStatusUpdate } from "@/helpers/fetchUtils";
import { isOwnerOrganizer} from "@/helpers/roleUtils";
import { secureStorage } from "@/services/secureStorage";
import defaultCompetitionImage from "@/assets/competition.jpg";

export default {
  name: "CompetitionsView",
  components: {
    CompetitionJudges,
    CompetitionJudge,
    CompetitionRounds,
    CompetitionAthletes,
    CompetitionActions,
    CompetitionHeader,
    CompetitionExtraInfo,
    CompetitionRoundSizes,
    CompetitionDetails,
    ConfirmationModal,
    CompetitionStageCalendar,
    RegisterAthleteModal,
    LoadingModal
  },
  data() {
    return {
      echoChannel: null,
      competitionUpdatedListener: null,
      queuedRoundUpserts: {},
      queuedReviewCounterUpdates: {},
      queuedRoundFetchIds: [],
      roundUpsertFlushHandle: null,
      reviewCounterFlushHandle: null,
      roundFetchFlushHandle: null,
      countdownReached: false,
      showCancel: false,
      modalMessage: "",
      // competitionArray: [],
      defaultImage: defaultCompetitionImage,
      showAthletes: false,
      showJudges: false,
      showRounds: false,
      stageCompleted: false,
      enableJudgesManual: false,
      enableRecordingManual: false,
      showRegisterModal: false,
      selectedCompetitionId: null,
      pendingStartCompetitionId: null,
      pendingAction: null,
      pendingPayload: null,
    };
  },
  computed: {
    ...mapState("competition",["competitionIdToView", "competitionData","appNavigation"]),
    ...mapState("competition_users",["competitionUsers","atheletesListArray","judgesListArray"]),
    ...mapState("round",["competitionRounds","competitionPodiums","roundCompetitionIdToEdit","roundCompetitionIdToView","roundCompetitionIdToCreate"]),
    ...mapState('user', ['isAuthenticated','user','token']),
    competitionArray() {
      return this.competitionData || [];
    },
    athletes() {
      return this.competitionUsers || [];
    },
    judges() {
      return this.competitionUsers || [];
    },
    stageCalendars() {
      const calendars = this.competitionArray?.stageCalendars || this.competitionArray?.stage_calendars;
      return Array.isArray(calendars) ? calendars : [];
    },
    showStageCalendar() {
      return Number(this.competitionArray?.type_id) === 1 && this.stageCalendars.length > 0;
    },
    athletes_list() {
      return this.atheletesListArray;
    },
    routeCompetitionId() {
      const rawId = this.$route.query?.id || this.$route.params?.id;
      const parsed = parseInt(rawId, 10);
      return Number.isFinite(parsed) ? parsed : null;
    },
    judges_list() {
      return this.judgesListArray;
    },
    hasActions() {
      const competition = this.competitionArray || {};
      const isPublished = Boolean(competition.publish_at);
      const isStarted = Boolean(competition.started_at);
      const isFinished = Boolean(competition.finished_at);
      const isOrganizer = this.isOwnerOrganizer(this.user, competition);
      const isJudgeNormalized = (this.competitionUsers || []).some((cu) => {
        const userId = Number(cu.user_id ?? cu.user?.id);
        const roleId = Number(cu.role_id ?? cu.user?.role_id);
        const statusId = Number(cu.status_id ?? cu.user?.status_id);
        return userId === Number(this.user?.id) && roleId === 2 && statusId === 4;
      });

      const canViewGroup = isPublished; // botones de vista requieren publicada
      const canStart = isPublished && isOrganizer && !isStarted;
      const judgeActions = isStarted && !isFinished && isJudgeNormalized;

      return canViewGroup || canStart || judgeActions;
    }
  },
  async mounted() {
    // Paso 1: cargar listas relacionadas (esto siempre)
    await this.prepareCompetitionEntry();

    const competitionId = this.routeCompetitionId || this.competitionIdToView;
    const localCompetition = this.competitionData;
    const missingCompetitionUsers = !Array.isArray(localCompetition?.competition_users) || localCompetition.competition_users.length === 0;
    const missingTechMeta = !missingCompetitionUsers && !(localCompetition?.competition_users || []).some(u => {
      const pivot = u?.pivot || {};
      return [
        u?.tech_operator_active,
        u?.tech_operator_qualified,
        u?.role_id,
        u?.status_id,
        pivot.tech_operator_active,
        pivot.tech_operator_qualified,
        pivot.role_id,
        pivot.status_id,
      ].some(v => v !== undefined && v !== null);
    });
    const cameFromNotification = this.$route?.query?.from === 'notification' || this.appNavigation?.competition?.cameFromNotification;

    if (!competitionId) {
      console.warn("❌ No se encontró competitionIdToView");
      return;
    }
    this.echoChannel = echoService.channel(`competition.${competitionId}`);

    this.echoChannel
        .listen('.CompetitionUsersUpdated', (e) => {
          const payload = this.normalizeCompetitionUserEvent(e);
          if (!this.isCurrentCompetition(payload?.competition_id || payload?.competition?.id)) return;
          this.updateCompetitionUser(payload);
        })
        .listen('.CompetitionUserCreated', (e) => {
          const payload = this.normalizeCompetitionUserEvent(e);
          if (!this.isCurrentCompetition(payload?.competition_id || payload?.competition?.id)) return;
          this.updateCompetitionUser(payload);
        })
        .listen('.CompetitionUserUpdate', (e) => {
          const payload = this.normalizeCompetitionUserEvent(e);
          if (!this.isCurrentCompetition(payload?.competition_id || payload?.competition?.id)) return;
          this.updateCompetitionUser(payload);
        })
        .listen('.CompetitionUpdated', (e) => {
          if (!this.isCurrentCompetition(e?.competition?.id)) return;
          this.setCompetition(e.competition);
        })
        .listen('.CompetitionUpdatedById', async (e) => {
          if (!this.isCurrentCompetition(e?.competition_id)) return;
          await this.fetchUserCompetition(e.competition_id);
        })
        .listen('.RoundsBatchUpdated', (e) => {
          this.queueRoundsBatchUpdate(e);
        })
        .listen('.RoundUpdated', (e) => {
          this.queueRoundUpsert(e?.round);
        })
        .listen('.ReviewCounter', (e) => {
          this.queueReviewCounterUpdate({
            round_id: e.round_id,
            count: e.count_negative_feedback,
          });
        })
        .listen('.PartialRoundUpdated', (e) => {
          this.queueRoundUpsert(e);
        })
        .listen('.PartialCompetitionUpdated', (e) => this.upsertCompetition(e))
        .listen('.CreateRoundUpdated', (e) => {
          this.queueRoundUpsert(e);
        })
        .listen('.CreatePodiumUpdated', (e) => this.upsertPodium(e))
        .listen('.AthleteSummaryUpdated', (e) => {
          const { summary, competitionId } = this.normalizeSummaryPayload(e);
          if (!summary) return;
          const safeSummary = this.enrichSummary(summary, competitionId);

          this.setAthleteSummaryBar(safeSummary);

          if (this.isCurrentCompetition(competitionId)) {
            this.upsertCompetition({ athletes_summary: safeSummary });
          }
        })
        .error(error => {
          console.error('❌ Error en WebSocket:', error);
        });

    // Listener para refrescar cuando se actualiza desde NotificationsView
    if (!this.competitionUpdatedListener) {
      this.competitionUpdatedListener = (event) => {
        const detailCompetitionId = Number(event?.detail?.competitionId ?? event?.detail?.competition_id ?? 0);
        const targetCompetitionId = detailCompetitionId || this.competitionIdToView;
        if (targetCompetitionId) {
          this.fetchUserCompetition(targetCompetitionId);
        }
      };
    }
    window.addEventListener('competition:updated', this.competitionUpdatedListener);

    if (this.appNavigation.competition?.cameFromJudgingManual) {
      const currentCompetitionUser = this.getCurrentCompetitionUser();
      if (this.isTechOperatorActive(currentCompetitionUser)) {
        this.enableRecordingManual = true;
        this.enableJudgesManual = false;
      } else {
        this.enableJudgesManual = true;
        this.enableRecordingManual = false;
      }
      // this.clearAppNavigationZone("competition");
    }
    if (this.appNavigation.competition?.cameFromViewRound) {
      this.showRounds = true;
      // this.clearAppNavigationZone("competition");
    }
    if (this.appNavigation.competition?.cameFromShowJudges) {
      this.showJudges = true;
      this.clearAppNavigationZone("competition");
    }
    if (this.appNavigation.competition?.cameFromShowAthletes) {
      this.showAthletes = true;
      this.clearAppNavigationZone("competition");
    }

    // Paso 3: Si venimos de notificación o no hay datos en store/session, forzar fetch inicial
    if (cameFromNotification || missingCompetitionUsers || missingTechMeta || !localCompetition || !localCompetition.id || localCompetition.id !== competitionId) {
      await this.fetchUserCompetition(competitionId);
    } else if (this.appNavigation.competition?.needsRefreshOnReturn) {
      await this.fetchUserCompetition(competitionId);
      this.updateAppNavigationZone({
        zone: 'competition',
        data: { needsRefreshOnReturn: false },
      });
    }

    // Apertura inicial según estado de la competición
    if (!this.showAthletes && !this.showJudges && !this.showRounds && !this.enableJudgesManual && !this.enableRecordingManual) {
      const statusId = Number(this.competitionArray?.status_id ?? this.competitionArray?.statusId ?? this.competitionData?.status_id);
      const currentCompetitionUser = this.getCurrentCompetitionUser();
      const isJudgeActive = this.isActiveJudge(currentCompetitionUser);
      // 10: publicada → mostrar atletas (inscripciones)
      if (statusId === 10) {
        this.showAthletes = true;
        this.showRounds = false;
        this.showJudges = false;
      // 8: finalizada → abrir podio (se maneja dentro de CompetitionRounds al estar en rounds)
      } else if (statusId === 8) {
        this.showRounds = true;
        this.showAthletes = false;
        this.showJudges = false;
      // 15: en curso → abrir rondas (última activa la decide CompetitionRounds)
      } else if (statusId === 15) {
        if (isJudgeActive) {
          // Solo una vista a la vez para jueces activos
          this.showRounds = false;
          this.showAthletes = false;
          this.showJudges = false;
          this.enableRecordingManual = false;
          this.enableJudgesManual = false;
          const isTechJudgeActive = this.isTechOperatorActive(currentCompetitionUser) && this.isDesktopDevice();

          this.setManualNavigationToLatestStage();

          // Técnico activo: abre la tabla de video (CompetitionJudge con allowRecording)
          if (isTechJudgeActive) {
            this.enableRecordingManual = true;
            this.enableJudgesManual = false;
          } else {
            // Juez activo no técnico: abre la tabla de puntuación
            this.enableJudgesManual = true;
            this.enableRecordingManual = false;
          }
        } else {
          this.showRounds = true;
          this.showAthletes = false;
          this.showJudges = false;
        }
      } else {
        // fallback: atletas
        this.showAthletes = false;
      }
    }
  },
  unmounted() {
    const competitionId = this.competitionIdToView || this.routeCompetitionId || this.competitionArray?.id;
    if (this.roundUpsertFlushHandle) {
      clearTimeout(this.roundUpsertFlushHandle);
      this.roundUpsertFlushHandle = null;
    }
    if (this.reviewCounterFlushHandle) {
      clearTimeout(this.reviewCounterFlushHandle);
      this.reviewCounterFlushHandle = null;
    }
    if (this.roundFetchFlushHandle) {
      clearTimeout(this.roundFetchFlushHandle);
      this.roundFetchFlushHandle = null;
    }

    if (this.echoChannel && competitionId) {
      this.echoChannel
          .stopListening('.CompetitionUsersUpdated')
          .stopListening('.CompetitionUserCreated')
          .stopListening('.CompetitionUserUpdate')
          .stopListening('.CompetitionUpdated')
          .stopListening('.CompetitionUpdatedById')
          .stopListening('.RoundsBatchUpdated')
          .stopListening('.RoundUpdated')
          .stopListening('.ReviewCounter')
          .stopListening('.PartialRoundUpdated')
          .stopListening('.PartialCompetitionUpdated')
          .stopListening('.CreateRoundUpdated')
          .stopListening('.CreatePodiumUpdated')
          .stopListening('.AthleteSummaryUpdated');

      echoService.leave(`competition.${competitionId}`);

      this.echoChannel = null;
    }

    if (this.competitionUpdatedListener) {
      window.removeEventListener('competition:updated', this.competitionUpdatedListener);
      this.competitionUpdatedListener = null;
    }
  },
  watch: {
    async routeCompetitionId(newId, oldId) {
      const normalizedNewId = Number(newId || 0);
      const normalizedOldId = Number(oldId || 0);

      if (!normalizedNewId || normalizedNewId === normalizedOldId) {
        return;
      }

      await this.prepareCompetitionEntry();
      await this.fetchUserCompetition(normalizedNewId);
    },
    showAthletes(val) {
      if (val) this.scrollToSection();
    },
    showJudges(val) {
      if (val) this.scrollToSection();
    },
    showRounds(val) {
      if (val) this.scrollToSection();
    },
    enableJudgesManual(val) {
      if (val) this.scrollToSection();
    },
    enableRecordingManual(val) {
      if (val) this.scrollToSection();
    }
  },
  methods: {
    ...mapActions("competition",["clearCompetition","clearCompetitionIdToView","setCompetition","setCompetitionIdToView","upsertCompetition","updateAppNavigationZone","clearAppNavigationZone"]),
    ...mapActions("competition_users",["setCompetitionUsers","updateCompetitionUser","clearCompetitionUsers","setAtheletesListArray","setJudgesListArray","clearAtheletesListArray","clearJudgesListArray"]),
    ...mapActions("round",["setAllRounds","setAllPodiums","upsertRound","upsertPodium","clearRound","clearPodium","setRoundAthleteId","setRoundCompetitionIdToCreate","setRoundCompetitionIdToView","setRoundCompetitionIdToEdit","clearCompetitionRoundIdToView","clearCompetitionRoundIdToCreate","clearCompetitionRoundIdToEdit","upsertNegativeFeedbackCount"]),
    ...mapActions("athlete_summary", ["setAthleteSummaryBar"]),
    fetchStatusUpdate,
    isOwnerOrganizer,
    normalizeCompetitionUserEvent(eventPayload) {
      const raw = eventPayload?.data ?? eventPayload;
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw);
        } catch (error) {
          console.warn('⚠️ No se pudo parsear CompetitionUser event', raw, error);
          return eventPayload;
        }
      }
      return raw;
    },
    queueRoundUpsert(roundPayload) {
      const round = roundPayload && typeof roundPayload === 'object' ? roundPayload : null;
      if (!round?.id) {
        if (round) {
          this.upsertRound(round);
        }
        return;
      }

      const existing = this.queuedRoundUpserts[round.id] || {};
      this.queuedRoundUpserts = {
        ...this.queuedRoundUpserts,
        [round.id]: { ...existing, ...round },
      };

      if (this.roundUpsertFlushHandle) {
        clearTimeout(this.roundUpsertFlushHandle);
      }

      this.roundUpsertFlushHandle = setTimeout(() => {
        this.flushQueuedRoundUpserts();
      }, 120);
    },
    flushQueuedRoundUpserts() {
      if (this.roundUpsertFlushHandle) {
        clearTimeout(this.roundUpsertFlushHandle);
        this.roundUpsertFlushHandle = null;
      }

      const queued = Object.values(this.queuedRoundUpserts || {});
      this.queuedRoundUpserts = {};

      queued.forEach((round) => {
        this.upsertRound(round);
      });
    },
    queueReviewCounterUpdate(update) {
      const roundId = Number(update?.round_id);
      if (!Number.isFinite(roundId) || roundId <= 0) {
        return;
      }

      this.queuedReviewCounterUpdates = {
        ...this.queuedReviewCounterUpdates,
        [roundId]: update,
      };

      if (this.reviewCounterFlushHandle) {
        clearTimeout(this.reviewCounterFlushHandle);
      }

      this.reviewCounterFlushHandle = setTimeout(() => {
        this.flushQueuedReviewCounterUpdates();
      }, 120);
    },
    flushQueuedReviewCounterUpdates() {
      if (this.reviewCounterFlushHandle) {
        clearTimeout(this.reviewCounterFlushHandle);
        this.reviewCounterFlushHandle = null;
      }

      const queued = Object.values(this.queuedReviewCounterUpdates || {});
      this.queuedReviewCounterUpdates = {};

      queued.forEach((payload) => {
        this.upsertNegativeFeedbackCount(payload);
      });
    },
    queueRoundsBatchUpdate(eventPayload) {
      const rounds = eventPayload?.rounds || eventPayload?.round_ids;
      if (!Array.isArray(rounds) || !rounds.length) {
        return;
      }

      if (typeof rounds[0] === 'object') {
        this.setAllRounds(rounds);
        return;
      }

      const nextIds = new Set([
        ...this.queuedRoundFetchIds,
        ...rounds.filter((id) => Number.isFinite(Number(id))).map((id) => Number(id)),
      ]);
      this.queuedRoundFetchIds = [...nextIds];

      if (this.roundFetchFlushHandle) {
        clearTimeout(this.roundFetchFlushHandle);
      }

      this.roundFetchFlushHandle = setTimeout(() => {
        this.flushQueuedRoundFetchIds();
      }, 160);
    },
    async flushQueuedRoundFetchIds() {
      if (this.roundFetchFlushHandle) {
        clearTimeout(this.roundFetchFlushHandle);
        this.roundFetchFlushHandle = null;
      }

      const ids = [...this.queuedRoundFetchIds];
      this.queuedRoundFetchIds = [];
      if (!ids.length) {
        return;
      }

      await this.fetchRoundsByIds(ids);
    },
    isCurrentCompetition(eventCompetitionId) {
      const currentId = Number(this.competitionIdToView || this.routeCompetitionId || this.competitionArray?.id);
      const eventId = Number(eventCompetitionId);
      return Number.isFinite(currentId) && Number.isFinite(eventId) && currentId === eventId;
    },
    safeParse(value) {
      if (typeof value !== 'string') return value;
      try {
        return JSON.parse(value);
      } catch (err) {
        console.warn('⚠️ No se pudo parsear el payload de summary', value, err);
        return null;
      }
    },
    normalizeSummaryPayload(payload) {
      const parsedEvent = this.safeParse(payload) || payload || {};
      const rawSummary = parsedEvent?.summary ?? parsedEvent?.data ?? null;
      const parsedSummary = this.safeParse(rawSummary) || rawSummary;
      const summary = this.safeParse(parsedSummary?.summary) || parsedSummary?.summary || parsedSummary;
      const competitionId = Number(
          parsedEvent?.competition_id ??
          parsedSummary?.competition_id ??
          summary?.competition_id ??
          parsedEvent?.competitionId ??
          parsedSummary?.competitionId ??
          summary?.competitionId
      );

      return { summary, competitionId: Number.isFinite(competitionId) ? competitionId : null };
    },
    enrichSummary(summary, competitionId) {
      const comp = this.isCurrentCompetition(competitionId) ? this.competitionData : null;
      const fallbackMin = Number(comp?.athletes_min);
      const existingSummary = comp?.athletes_summary || {};
      const minFromExisting = Number(existingSummary?.min_approved);

      const min_approved = Number.isFinite(summary?.min_approved)
        ? summary.min_approved
        : Number.isFinite(fallbackMin) && fallbackMin > 0
          ? fallbackMin
          : Number.isFinite(minFromExisting) && minFromExisting > 0
            ? minFromExisting
            : summary?.active_total;

      const athlete_count = Number.isFinite(summary?.athlete_count)
        ? summary.athlete_count
        : summary?.active_total;

      return {
        ...summary,
        min_approved,
        athlete_count,
      };
    },
    extractCalendarTimes(round) {
      if (!round || typeof round !== 'object') return { opens: null, closes: null, publish: null };
      const calendar = round.stage_calendar || round.calendar || {};
      const opens = calendar.upload_opens_at
        || calendar.upload_open_at
        || calendar.uploadOpensAt
        || calendar.uploadOpenAt
        || calendar.opens_at
        || calendar.open_at
        || calendar.opensAt
        || calendar.openAt
        || calendar.opens
        || round.upload_opens_at
        || round.upload_open_at
        || round.opens_at
        || round.open_at
        || null;
      const closes = calendar.upload_closes_at
        || calendar.upload_close_at
        || calendar.uploadClosesAt
        || calendar.uploadCloseAt
        || calendar.closes_at
        || calendar.close_at
        || calendar.closesAt
        || calendar.closeAt
        || calendar.closes
        || round.upload_closes_at
        || round.upload_close_at
        || round.closes_at
        || round.close_at
        || null;
      const publish = calendar.publish_at
        || calendar.published_at
        || calendar.publishAt
        || calendar.publishedAt
        || round.publish_at
        || round.published_at
        || round.publishAt
        || round.publishedAt
        || null;
      return { opens, closes, publish };
    },
    handleCountdownComplete() {
      this.countdownReached = true;
    },
    async fetchUserCompetition(id) {
      const storedToken = secureStorage.getItem('token') || localStorage.getItem('token');
      const token = this.token || (storedToken ? storedToken.replace(/"/g, '') : null);
      if (!token) {
        console.warn('⚠️ Sin token para fetchUserCompetition, se omite la llamada');
        return;
      }
      this.showLoading();
      try {
        const response = await this.$axios.get(`/competition/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200 && response.data?.competition) {
          await this.setCompetition(response.data?.competition);
          await this.setCompetitionUsers(response.data.competition?.competition_users);
          await this.setAllRounds(response.data.competition?.rounds);
          await this.setAllPodiums(response.data.competition?.podiums);
          if (response.data?.competition.publish_at && !response.data?.competition.started_at && this.isOwnerOrganizer(this.user,response.data?.competition)){
            await this.fetchAthelteList();
            await this.fetchJudgesList();
          }
        }
      } catch (error) {
        const status = Number(error?.response?.status || 0);
        if ([401, 403].includes(status)) {
          console.warn('⚠️ Sin acceso para refrescar la competencia actual', {
            competitionId: id,
            status,
          });
          return;
        }
        console.error("❌ Error al obtener la competencia:", error);
      } finally {
        this.hideLoading();
      }
    },
    async fetchAthelteList() {
      this.showLoading();
      try {
        const response = await this.$axios.get(`/athletes/list_short`, {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (response.status === 200 && response.data?.athletes) {
          this.setAtheletesListArray(response.data.athletes);
        }
      } catch (error) {
        console.error("❌ Error al obtener la competencia:", error);
      } finally {
        this.hideLoading();
      }
    },
    async fetchJudgesList() {
      this.showLoading();
      try {
        const competitionId = this.competitionData?.id || this.competitionIdToView;
        const response = await this.$axios.get(`/judges/list_short`, {
          headers: { Authorization: `Bearer ${this.token}` },
          params: competitionId ? { competition_id: competitionId } : {},
        });
        if (response.status === 200 && response.data?.judges) {
          this.setJudgesListArray(response.data.judges);
        }
      } catch (error) {
        console.error("❌ Error al obtener la competencia:", error);
      } finally {
        this.hideLoading();
      }
    },
    async toggleTechOperator({ competitionUserId, active }) {
      const competitionId = this.competitionData?.id || this.competitionIdToView;
      if (!competitionId || !competitionUserId) return;
      this.showLoading();
      try {
        const response = await this.$axios.post(
          `/judges/tech-operator`,
          {
            competition_id: competitionId,
            competition_user_id: competitionUserId,
            active: Boolean(active),
          },
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        );

        if (response.status === 200 && response.data?.success) {
          const updatedUsers = (this.competitionUsers || []).map((user) => {
            if (Number(user.id) === Number(competitionUserId)) {
              return {
                ...user,
                tech_operator_active: response.data?.competition_user?.tech_operator_active ? 1 : 0,
              };
            }
            if (active) {
              return { ...user, tech_operator_active: 0 };
            }
            return user;
          });
          await this.setCompetitionUsers(updatedUsers);
        }
      } catch (error) {
        const message = error?.response?.data?.error || error?.response?.data?.message || 'No se pudo actualizar el tecnico.';
        this.showCancel = false;
        this.modalMessage = message;
        this.$refs.confirmationModal.openModal();
      } finally {
        this.hideLoading();
      }
    },
    async fetchInvitateAtheltes(competition_id, athletesArrayIds, emailList) {
      this.showLoading();
      try {
        const response = await this.$axios.post(`/athletes/invitation`, {
          competition_id: competition_id,
          athletes_list: athletesArrayIds,
          email_list: emailList
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (response.status === 200) {
          this.hideLoading();
        } else {
          console.log('⚠️ Falló el envío');
          this.hideLoading();
        }
      } catch (error) {
          this.hideLoading();
        console.log('❌ Error al invitar atletas');
      }
    },
    async fetchOrderAthletes(competition_id, athletes) {
      this.showLoading();
      try {
        const response = await this.$axios.post(`/athletes/order_list`, {
          competition_id,
          athletes_list: athletes
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (response.status === 200 && response.data?.success) {
          this.applyLocalOrder(athletes);
          const comp = response.data?.competition || response.data;
          if (comp && (comp.athletes_ordered_at || comp.athletes_ordered_by)) {
            this.upsertCompetition({
              athletes_ordered_at: comp.athletes_ordered_at,
              athletes_ordered_by: comp.athletes_ordered_by,
            });
          }
          // Refresca desde el backend por si hay normalización extra del controlador
          await this.fetchUserCompetition(competition_id);
        } else {
          console.log('⚠️ Falló el envío');
        }
      } catch (error) {
        console.log('❌ Error al order atletas', error);
      } finally {
        this.hideLoading();
      }
    },
    async fetchInvitateJudges(competition_id,judgesArrayIds) {
      this.showLoading();
      try {
        const  response = await this.$axios.post(`/judges/invitation`, {
          competition_id: competition_id,
          judges_list: judgesArrayIds,
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        if (response.status === 200) {
          this.hideLoading();
        } else {
          console.log('⚠️ Falló el envío');
          this.hideLoading();
        }
      } catch (error) {
        console.error("❌ Error invitation:", error);
      } finally {
        this.hideLoading();
      }
    },
    showLoading() {
      this.$nextTick(() => {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.showLoading();
        }
      });
    },
    hideLoading() {
      this.$nextTick(() => {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hideLoading();
        }
      });
    },
    async confirmModal() {
      if (this.pendingAction === 'publish-stage' && this.pendingPayload) {
        await this.performPublishStage(this.pendingPayload);
      } else if (this.pendingAction === 'advance-stage' && this.pendingPayload) {
        await this.performAdvanceStage(this.pendingPayload);
      } else if (this.pendingStartCompetitionId) {
        await this.startCompetition(this.pendingStartCompetitionId);
      }
      this.pendingStartCompetitionId = null;
      this.pendingAction = null;
      this.pendingPayload = null;
    },
    cancelModal() {
      this.pendingStartCompetitionId = null;
      this.pendingAction = null;
      this.pendingPayload = null;
    },
    handleRegister(id) {
      this.openRegisterModal(id);
    },
    handleRegistered(competition_id) {
      this.confirmRegistration(competition_id)
    },
    openRegisterModal(id) {
      this.selectedCompetitionId = id;
      this.showRegisterModal = true;
    },
    handleViewAthletes() {
      this.showAthletes = !this.showAthletes;
      if (this.showAthletes) {
        this.showRounds = false;
        this.showJudges = false;
        this.enableJudgesManual = false;
        this.enableRecordingManual = false;
      }
    },
    handleViewJudges() {
      this.showJudges = !this.showJudges;
      if (this.showJudges) {
        this.showRounds = false;
        this.showAthletes = false;
        this.enableJudgesManual = false;
        this.enableRecordingManual = false;
      }
    },
    handleViewRounds() {
      this.showRounds = !this.showRounds;
      if (this.showRounds) {
        this.showAthletes = false;
        this.showJudges = false;
        this.enableJudgesManual = false;
        this.enableRecordingManual = false;
      }
    },
    handleOpenScoring() {
      this.enableJudgesManual = !this.enableJudgesManual;
      this.enableRecordingManual = false;
      if (this.enableJudgesManual) {
        this.setManualNavigationToLatestStage();
        this.showRounds = false;
        this.showAthletes = false;
        this.showJudges = false;
      }
    },
    handleOpenRecording() {
      this.enableRecordingManual = !this.enableRecordingManual;
      this.enableJudgesManual = false;
      if (this.enableRecordingManual) {
        this.setManualNavigationToLatestStage();
        this.showRounds = false;
        this.showAthletes = false;
        this.showJudges = false;
      }
    },
    handleRoundSizesLockedAll(list) {
      const incoming = Array.isArray(list)
        ? list
        : (list && typeof list === 'object') ? [list] : [];
      const locked = incoming.map(item => ({ ...item, locked: true }));
      this.$store.dispatch('competition/upsertCompetition', {
        round_sizes: locked,
        roundSizes: locked,
      });
    },
    async handleOrderFromActions() {
      this.showAthletes = true;
      this.showRounds = false;
      this.showJudges = false;
      this.enableJudgesManual = false;
      this.enableRecordingManual = false;
      await this.$nextTick();
      if (this.$refs.competitionAthletes && typeof this.$refs.competitionAthletes.openOrderModalExternal === 'function') {
        this.$refs.competitionAthletes.openOrderModalExternal();
      }
    },
    handleStartScoring(id) {
      const isLive = Number(this.competitionArray?.type_id) === 2;
      if (isLive) {
        const hasActiveTech = (this.competitionUsers || []).some(user => {
          const isJudge = Number(user?.role_id) === 2;
          const qualified = this.isTruthyFlag(user?.tech_operator_qualified);
          const active = this.isTruthyFlag(user?.tech_operator_active);
          return isJudge && qualified && active;
        });

        if (!hasActiveTech) {
          this.pendingStartCompetitionId = null;
          this.modalMessage = this.$t('competitions.tech_operator_required') || 'Se necesita al menos un tecnico activo para iniciar la competencia en vivo.';
          this.showCancel = false;
          this.$refs.confirmationModal.openModal();
          return;
        }
      }
      // Solicita confirmación antes de iniciar la competencia
      this.pendingStartCompetitionId = id;
      this.modalMessage = this.$t('competitions.modal.start_competition_confirmation');
      this.showCancel = true;
      this.$refs.confirmationModal.openModal();
    },
    async startCompetition(id) {
      this.showLoading();
      try {
        const response = await this.$axios.get(`/competition/start/${id}`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        if (response.status === 200 && response.data?.competition) {
          this.showAthletes = false;
          this.showJudges = false;
          this.showRounds = false;
          this.enableJudgesManual = false;
          this.enableRecordingManual = false;
          this.setCompetition(response.data.competition);
        } else {
          console.warn("⚠️ PASO 6: Respuesta inesperada de la API:", response);
        }
      } catch (error) {
        console.error("❌ PASO 6: Error al obtener la competencia:", error);
      } finally {
        this.hideLoading();
      }
    },
    async startRecordingAthlete(round) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'rounds', round.id, 16,null);
      if (response.data?.success) {
        this.hideLoading();
      } else {
        console.log('⚠️ Falló el envío');
        this.hideLoading();
      }
    },
    async stopRecordingAthlete(round) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'rounds', round.id, 17, null);
      if (response.data?.success) {
        this.hideLoading();
      } else {
        this.hideLoading();
        console.log('⚠️ Falló el envío');
      }
    },
    async scoreAthlete({ athlete, stageName, roundNumber, tablePage, tablePairPage }) {
      try {
        this.showLoading();
        const response = await this.fetchStatusUpdate(this.token, 'rounds', athlete.id, 6,null);

        if (response.data?.success) {
          this.setRoundCompetitionIdToCreate(athlete.id);
          // 👇 Guardamos en navegación que venimos desde jueces
          this.updateAppNavigationZone({
            zone: "competition",
            data: {
              cameFromJudgingManual: true,
              cameFromScoreRound: true,
              scoreRoundRestoreStatus: 17,
              stageName: stageName,
              roundNumber: roundNumber,
              judgeTablePage: tablePage,
              judgeTablePairPage: tablePairPage,
            }
          });
          this.hideLoading();
          await router.push('/score');
        } else {
          this.hideLoading();
          this.modalMessage = response?.data?.message || '⚠️ No se pudo iniciar la calificación.';
          this.showCancel = false;

          this.$refs.confirmationModal.openModal();
        }
      } catch (error) {
        this.hideLoading();
        this.modalMessage = error?.response?.data?.message || '⚠️ Error inesperado al iniciar la calificación.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    async editScore({ athlete, stageName, roundNumber, tablePage, tablePairPage }) {
      try {
        this.showLoading();
        const response = await this.fetchStatusUpdate(this.token, 'rounds', athlete.id, 22, null);

        if (response.data?.success) {
          this.setRoundCompetitionIdToEdit(athlete.id);
          this.updateAppNavigationZone({
            zone: "competition",
            data: {
              cameFromJudgingManual: true,
              stageName: stageName,
              roundNumber: roundNumber,
              judgeTablePage: tablePage,
              judgeTablePairPage: tablePairPage,
            }
          });
          this.hideLoading();
          await router.push('/score');
        } else {
          this.hideLoading();
          this.modalMessage = response?.data?.message || '⚠️ No se pudo iniciar la calificación.';
          this.showCancel = false;

          this.$refs.confirmationModal.openModal();
        }
      } catch (error) {
        this.hideLoading();
        this.modalMessage = error?.response?.data?.message || '⚠️ Error inesperado al editar la calificación.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    async disqualifyAthlete(round) {
      try {
        this.showLoading();
        const response = await this.fetchStatusUpdate(this.token, 'rounds', round.id, 11, null);

        if (response.data?.success) {
          this.hideLoading();
        } else {
          this.hideLoading();
          this.modalMessage = response?.data?.message || '⚠️ No se pudo iniciar la calificación.';
          this.showCancel = false;

          this.$refs.confirmationModal.openModal();
        }
      } catch (error) {
        this.hideLoading();
        this.modalMessage = error?.response?.data?.message || '⚠️ Error inesperado al editar la calificación.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    async injuryAthlete(round) {
      try {
        this.showLoading();
        const response = await this.fetchStatusUpdate(this.token, 'rounds', round.id, 12, null);

        if (response.data?.success) {
          this.hideLoading();
        } else {
          this.hideLoading();
          this.modalMessage = response?.data?.message || '⚠️ No se pudo iniciar la calificación.';
          this.showCancel = false;

          this.$refs.confirmationModal.openModal();
        }
      } catch (error) {
        this.hideLoading();
        this.modalMessage = error?.response?.data?.message || '⚠️ Error inesperado al editar la calificación.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    advanceStage(competition_id,round_number) {
      this.pendingAction = 'advance-stage';
      this.pendingPayload = { competition_id, round_number };
      this.modalMessage = this.$t('rounds.confirm_advance') || '¿Confirmas avanzar de etapa? Esta acción no se puede revertir.';
      this.showCancel = true;
      this.$refs.confirmationModal.openModal();
    },
    async performAdvanceStage({ competition_id, round_number }) {
      this.showLoading();
      try {
        const data = {
          competition_id,
          round_number
        };
        const response = await this.fetchStatusUpdate(this.token,'advanceRounds', data, 13,null);
        if (!response.data?.success) {
          console.log('⚠️ Falló el envío');
        }
      } catch (error) {
        console.error('❌ Error al avanzar etapa', error);
      } finally {
        this.hideLoading();
      }
    },
    publishStage(rounds) {
      this.pendingAction = 'publish-stage';
      this.pendingPayload = rounds;
      this.modalMessage = this.$t('rounds.confirm_publish') || '¿Confirmas publicar la etapa? Esta acción no se puede revertir.';
      this.showCancel = true;
      this.$refs.confirmationModal.openModal();
    },
    async performPublishStage(rounds) {
      this.showLoading();
      try {
        const response = await this.fetchStatusUpdate(this.token,'publishRounds', rounds, 10,null);
        if (response.data?.success) {
          localStorage.removeItem(`publishCountdownStart_${this.competitionIdToView}`);
        } else {
          console.log('⚠️ Falló el envío');
        }
      } catch (error) {
        console.error('❌ Error al publicar etapa', error);
      } finally {
        this.hideLoading();
      }
    },
    async viewRound({athlete,selectedStage,selectedRound}) {
      try {
        this.showLoading();
        this.setRoundCompetitionIdToView(athlete.round_id);
        this.updateAppNavigationZone({
          zone: "competition",
          data: {
            cameFromViewRound: true,
            selectedStage: selectedStage,
            selectedRound: selectedRound
          }
        });
        await router.push('/score');
      } catch (error) {
        this.hideLoading();
        this.modalMessage = '⚠️ Error inesperado al ver la ronda.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    async reviewRound({athlete,selectedStage,selectedRound}) {
      try {
        this.showLoading();
        const response = await this.fetchStatusUpdate(this.token, 'rounds', athlete.round_id, 19,null);

        if (response.data?.success) {
          this.setRoundCompetitionIdToView(athlete.round_id);
          this.updateAppNavigationZone({
            zone: "competition",
            data: {
              cameFromViewRound: true,
              cameFromReviewRound: true,
              reviewRoundRestoreStatus: 7,
              reviewRoundRestoreSource: 'judge_panel',
              selectedStage: selectedStage,
              selectedRound: selectedRound
            }
          });
          await router.push('/score');
        } else {
          this.hideLoading();
          this.modalMessage = response?.data?.message || '⚠️ No se pudo iniciar la calificación.';
          this.showCancel = false;

          this.$refs.confirmationModal.openModal();
        }
      } catch (error) {
        this.hideLoading();
        this.modalMessage = '⚠️ Error inesperado al ver la ronda.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    async viewScore({athlete,stageName,roundNumber,tablePage,tablePairPage}) {
      try {
        this.showLoading();
        this.setRoundCompetitionIdToView(athlete.id);
        this.updateAppNavigationZone({
          zone: "competition",
          data: {
            cameFromJudgingManual: true,
            stageName: stageName,
            roundNumber: roundNumber,
            judgeTablePage: tablePage,
            judgeTablePairPage: tablePairPage,
          }
        });
        await router.push('/score');
      } catch (error) {
        this.hideLoading();
        this.modalMessage = '⚠️ Error inesperado al ver la ronda.';
        this.showCancel = false;
        this.$refs.confirmationModal.openModal();
      }
    },
    async fetchRoundsByIds(roundIds) {
      this.showLoading();
      try {
        const response = await this.$axios.get(`/rounds/batch`, {
          params: { ids: roundIds },
          headers: { Authorization: `Bearer ${this.token}` }
        });

        if (response.status === 200 && response.data?.rounds) {
          this.upsertRound(response.data.rounds);
        }
      } catch (error) {
        console.error("❌ Error al obtener rounds por IDs:", error);
      } finally {
        this.hideLoading();
      }
    },
    async updateAthleteStatus(payload) {
      const roundId = typeof payload === 'object' ? (payload.id || payload.roundId) : payload;
      const statusId = typeof payload === 'object' ? (payload.statusId || payload.status_id || 13) : 13;
      if (!roundId) return;
      try {
        this.showLoading();
        await this.fetchStatusUpdate(this.token, 'rounds', roundId, statusId, null);
      } catch (error) {
        console.error('❌ Error al actualizar estado del atleta', error);
      } finally {
        this.hideLoading();
      }
    },
    async viewAthlete(id) {
      this.updateAppNavigationZone({
        zone: "competition",
        data: {
          cameFromShowAthletes: true,
        }
      });
      await router.push(`/profile/${id}`);
    },
    async viewJudge(id) {
      this.updateAppNavigationZone({
        zone: "competition",
        data: {
          cameFromShowJudges: true,
        }
      });
      await router.push(`/profile/${id}`);
    },

    async viewJudges(id) {
      console.log("ID: " + id);
    },

    async rejectAthlete(id) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'athletes', id, 5,null); // 🔹 Usamos `await` para esperar la respuesta
      if (response.success) {
        this.hideLoading();
      } else {
        console.log('⚠️ Falló el envío');
        this.hideLoading();
        // this.$toast.error(response.data.message || 'Algo salió mal');
      }
    },
    async deleteAthlete(id) {
      try {
        this.showLoading();
        const response = await this.$axios.post('/athletes/delete', {
          competition_user_id: id
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          }
        });
        if (response.status === 200 && response.data?.competition_users) {
          this.setCompetitionUsers(response.data.competition_users);
        } else {
          console.log('⚠️ Falló el envío');
          // this.$toast.error(response.data.message || 'Algo salió mal');
        }
      } catch (error) {
        console.error("❌ Error registrando al atleta:", error);
      } finally {
        this.hideLoading();
      }
    },
    async rejectJudge(id) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'judges', id, 5,null); // 🔹 Usamos `await` para esperar la respuesta
      if (response.success) {
        // this.$toast.success(response.data.message);
        this.hideLoading();
      } else {
        console.log('⚠️ Falló el envío');
        this.hideLoading();
        // this.$toast.error(response.data.message || 'Algo salió mal');
      }
    },
    async deleteJudge(id) {
      try {
        this.showLoading();
        const response = await this.$axios.post('/judges/delete', {
          competition_user_id: id
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          }
        });
        if (response.status === 200 && response.data?.competition_users) {
          this.setCompetitionUsers(response.data.competition_users);
        } else {
          console.log('⚠️ Falló el envío');
          // this.$toast.error(response.data.message || 'Algo salió mal');
        }
      } catch (error) {
        console.error("❌ Error registrando al atleta:", error);
      } finally {
        this.hideLoading();
      }
    },
    async confirmPayment(id) {
      this.showLoading();
      try {
        const response = await this.$axios.post(`/athletes/paid`, {
          competition_user_id: id,
        },{
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (response.data.success) {
          // this.$toast.success(response.data.message);
          this.hideLoading();
        } else {
          console.log('⚠️ Falló el envío');
          this.hideLoading();
          // this.$toast.error(response.data.message || 'Algo salió mal');
        }
      } catch (error) {
        console.error("❌ Error al obtener la competencia:", error);
      } finally {
        this.hideLoading();
      }
    },
    async approveAthlete(id) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'athletes', id, 4,null); // 🔹 Usamos `await` para esperar la respuesta
      if (response.data?.success) {
        this.hideLoading();
        // this.$toast.success(response.data.message);
      } else {
        this.hideLoading();
        console.log('⚠️ Falló el envío');
        // this.$toast.error(response.data.message || 'Algo salió mal');
      }
    },
    async sendEmailToAthletes(id) {
      await this.sendEmailStatus(id, 'admin');
    },
    async sendEmailToAthlete(competitionUserId) {
      await this.sendEmailStatus(competitionUserId, 'admin');
    },
    async sendEmailStatus(targetId, source = null) {
      this.showLoading();
      try {
        const response = await this.fetchStatusUpdate(this.token,'athletes', targetId, 2, source); // 🔹 Usamos `await` para esperar la respuesta
        if (!(response.status === 200 && response.data)) {
          console.log('⚠️ Falló el envío');
        }
      } catch (error) {
        console.error('❌ Error al enviar correo individual:', error);
      } finally {
        this.hideLoading();
      }
    },
    async sendEmailToJudges(id) {
      await this.sendEmailStatusJudge(id, 'admin');
    },
    async sendEmailToJudge(competitionUserId) {
      await this.sendEmailStatusJudge(competitionUserId, 'admin');
    },
    async sendEmailStatusJudge(targetId, source = null) {
      this.showLoading();
      try {
        const response = await this.fetchStatusUpdate(this.token,'judges', targetId, 2, source);
        if (!(response.status === 200 && response.data)) {
          console.log('⚠️ Falló el envío');
        }
      } catch (error) {
        console.error('❌ Error al enviar correo a juez:', error);
      } finally {
        this.hideLoading();
      }
    },
    async approveJudge(id) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'judges', id, 4,null);
      if (response.data?.success) {
        // this.$toast.success(response.data.message);
        this.hideLoading();
      } else {
        this.hideLoading();
        console.log('⚠️ Falló el envío');
        // this.$toast.error(response.data.message || 'Algo salió mal');
      }
    },

    async confirmAthlete(id) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'athletes', id, 3,null); // 🔹 Usamos `await` para esperar la respuesta
      if (response.data?.success) {
        this.showLoading();
        // this.$toast.success(response.data.message);
        this.hideLoading();
      } else {
        console.log('⚠️ Falló el envío');
        this.hideLoading();
        // this.$toast.error(response.data.message || 'Algo salió mal');
      }
    },
    async confirmJudge(id) {
      this.showLoading();
      const response = await this.fetchStatusUpdate(this.token,'judges', id, 3,null); // 🔹 Usamos `await` para esperar la respuesta
      if (response.data?.success) {
        // this.$toast.success(response.data.message);
        this.hideLoading();
      } else {
        console.log('⚠️ Falló el envío');
        this.hideLoading();
        // this.$toast.error(response.data.message || 'Algo salió mal');
      }
    },

    inviteAthlete(athletes,emails) {
      let competition_id = this.competitionArray.id;
      this.fetchInvitateAtheltes(competition_id,athletes,emails);
    },
    inviteJudges(judges) {
      let competition_id = this.competitionArray.id;
      this.fetchInvitateJudges(competition_id,judges);
    },
    orderAthletes(athletes) {
      const competition_id = this.competitionArray.id;

      // Simplificar el array antes de enviarlo
      const simplifiedAthletes = athletes.map(a => ({
        id: a.id, // id del competition_user
        order_number: a.order_number
      }));

      this.fetchOrderAthletes(competition_id, simplifiedAthletes);
    },

    applyLocalOrder(orderedList) {
      if (!Array.isArray(orderedList)) return;
      const orderMap = new Map(orderedList.map(a => [a.id, a.order_number]));

      const updateOrder = user => {
        if (!orderMap.has(user.id)) return user;
        const order_number = orderMap.get(user.id);
        return {
          ...user,
          order_number,
          pivot: user.pivot ? { ...user.pivot, order_number } : user.pivot
        };
      };

      const updatedUsers = Array.isArray(this.competitionUsers)
          ? this.competitionUsers.map(updateOrder)
          : [];
      this.setCompetitionUsers(updatedUsers);

      if (this.competitionArray && Array.isArray(this.competitionArray.competition_users)) {
        const updatedCompetition = {
          ...this.competitionArray,
          competition_users: this.competitionArray.competition_users.map(updateOrder)
        };
        this.setCompetition(updatedCompetition);
      }
    },


   /* async fetchStatusUpdate(entity, id, status_id){
      this.showLoading();
      try {
        const response = await this.$axios.post(`/status/update`, {
          entity: entity,
          id: id,
          new_status: status_id,
        },{
          headers: { Authorization: `Bearer ${this.token}` },
        });
        if (response.status === 200 && response?.data) {
          return response.data;
        }
      } catch (error) {
        console.error("❌ Error al obtener la competencia:", error);
      } finally {
        this.hideLoading();
      }
    },*/
    async onCancel() {
      this.cleanSession();
      await router.push('/competitions');
    },
    async prepareCompetitionEntry() {
      const targetCompetitionId = this.routeCompetitionId;
      const persistedCompetitionId = Number(this.competitionIdToView || 0) || null;
      const loadedCompetitionId = Number(this.competitionData?.id || 0) || null;
      const hasTargetCompetition = Number.isFinite(Number(targetCompetitionId)) && Number(targetCompetitionId) > 0;
      const shouldReplacePersistedContext = hasTargetCompetition && (
        Number(targetCompetitionId) !== Number(persistedCompetitionId || 0)
        || Number(targetCompetitionId) !== Number(loadedCompetitionId || 0)
      );

      this.clearCompetitionRoundIdToView();
      this.clearCompetitionRoundIdToCreate();
      this.clearCompetitionRoundIdToEdit();
      localStorage.removeItem('validatedTricks');
      localStorage.removeItem('selectedTricks');
      localStorage.removeItem('videoUrl');

      if (!shouldReplacePersistedContext) {
        if (targetCompetitionId && Number(this.competitionIdToView || 0) !== Number(targetCompetitionId)) {
          await this.setCompetitionIdToView(targetCompetitionId);
        }
        return;
      }

      this.resetCompetitionRuntimeState({ clearNavigationZone: true });
      await this.setCompetitionIdToView(targetCompetitionId);
    },
    resetCompetitionRuntimeState({ clearNavigationZone = false } = {}) {
      this.showAthletes = false;
      this.showJudges = false;
      this.showRounds = false;
      this.stageCompleted = false;
      this.enableJudgesManual = false;
      this.enableRecordingManual = false;
      this.showRegisterModal = false;

      if (clearNavigationZone) {
        this.clearAppNavigationZone('competition');
      }

      this.clearCompetition();
      this.clearCompetitionUsers();
      this.clearAtheletesListArray();
      this.clearJudgesListArray();
      this.clearRound();
      this.clearPodium();
    },
    cleanSession(){
      this.resetCompetitionRuntimeState({ clearNavigationZone: true });
      this.clearCompetitionIdToView();
    },
    refillNextStage(athletes) {
      const defaultAthleteTemplate = {
        id: null,
        competition_id: null,
        user_id: null,
        round_size_id: null,
        round_number: 1,
        total_score: 0,
        status_id: 13,
        user: {
          id: null,
          name: "Pendiente",
          surname: "",
          img_path: require('@/assets/user.png')
        }
      };

      return athletes
          .filter(athlete => athlete.status_id === 13 && athlete.role_id === 1) // Filtrar solo los atletas que cumplen la condición
          .map(athlete => ({
            ...defaultAthleteTemplate,
            competition_id: athlete.competition_id,
            user_id: athlete.user.id,
            user: {
              ...defaultAthleteTemplate.user,
              id: athlete.user.id,
              name: athlete.user.name,
              surname: athlete.user.surname,
              img_path: athlete.user.img_path || defaultAthleteTemplate.user.img_path
            }
          }));
    },
    async confirmRegistration(competition_id) {
      try {
        this.showLoading();
        const response = await this.$axios.post('/athletes/register', {
          user_id: this.user.id,
          competition_id: competition_id
        }, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          }
        });
        if (response.data.success) {
          // this.$toast.success(response.data.message);
          this.hideLoading();
        } else {
          console.log('⚠️ Falló el envío');
          this.hideLoading();
          // this.$toast.error(response.data.message || 'Algo salió mal');
        }
      } catch (error) {
        console.error("❌ Error registrando al atleta:", error);
      } finally {
        this.hideLoading();
      }
    },
    getCurrentCompetitionUser() {
      const uid = this.user?.id;
      if (!uid || !Array.isArray(this.competitionUsers)) return null;
      return this.competitionUsers.find(u => Number(u?.user_id ?? u?.user?.id) === Number(uid)) || null;
    },
    isActiveJudge(user) {
      if (!user) return false;
      const roleId = Number(user?.role_id ?? user?.pivot?.role_id ?? user?.user?.role_id);
      const statusId = Number(user?.status_id ?? user?.pivot?.status_id ?? user?.user?.status_id);
      return roleId === 2 && statusId === 4;
    },
    isActiveTech(user) {
      if (!this.isActiveJudge(user)) return false;
      const active = this.isTruthyFlag(user?.tech_operator_active ?? user?.pivot?.tech_operator_active);
      const qualified = this.isTruthyFlag(user?.tech_operator_qualified ?? user?.pivot?.tech_operator_qualified);
      return active && qualified;
    },
    isTechOperatorActive(user) {
      return this.isActiveTech(user);
    },
    setManualNavigationToLatestStage() {
      const rounds = Array.isArray(this.competitionRounds) ? this.competitionRounds : [];
      if (!rounds.length) return;

      const eliminationRounds = rounds.filter((round) => Number(round?.round_size_id) > 0);
      let stageName = null;
      let roundNumber = null;

      if (eliminationRounds.length) {
        const stageIds = eliminationRounds
          .map((round) => Number(round?.round_size_id))
          .filter((value) => Number.isFinite(value));

        if (stageIds.length) {
          stageName = String(Math.min(...stageIds));
        }
      } else {
        const hasQualification2 = rounds.some((round) => Number(round?.round_number) === 2);
        roundNumber = hasQualification2 ? 2 : 1;
      }

      this.updateAppNavigationZone({
        zone: 'competition',
        data: {
          cameFromJudgingManual: true,
          stageName,
          roundNumber,
        },
      });
    },
    scrollToSection() {
      this.$nextTick(() => {
        const el = this.$refs.sectionContainer;
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    isTruthyFlag(flag) {
      return flag === true || flag === 'true' || flag === 1 || flag === '1' || Number(flag) === 1;
    },
    isDesktopDevice() {
      if (typeof navigator === 'undefined') return true;
      const ua = navigator.userAgent || '';
      const mobileRe = /(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile|Tablet)/i;
      return !mobileRe.test(ua);
    }
  },
};
</script>

<style scoped>
.box_component {
  width: 100%;
  max-width: 100%;
  margin: 15px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.competition-view-shell {
  position: relative;
}

.competition-back-button {
  position: absolute;
  top: 10px;
  left: 18px;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 999px;
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.92);
  color: #1f2937;
  font-weight: 600;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.18);
}

.competition-back-button:hover {
  background: #ffffff;
}

.competition-back-button:focus-visible {
  outline: 2px solid #1f2937;
  outline-offset: 2px;
}
@media (max-width: 576px) {
  .box_component {
    padding: 5px;
  }

  .competition-back-button {
    top: 8px;
    left: 10px;
    padding: 7px 12px;
  }
}
</style>
